import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    title: "Features",
    link: "/features",
    submenu: [
      { id: 21, title: "All Modules", link: "/features" },
      { id: 22, title: "AI Characters", link: "/team" },
      { id: 23, title: "How It Connects", link: "/how-it-connects" },
    ],
  },
  {
    id: 6,
    title: "Industries",
    link: "/industries",
  },
  {
    id: 3,
    title: "Pricing",
    link: "/pricing",
  },
  {
    id: 4,
    title: "About",
    link: "/about",
  },
  {
    id: 5,
    title: "Contact",
    link: "/contact",
  },
];

const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p onClick={() => handleToggle(menu.id)}>
                {menu.title}
                <i
                  className={
                    openId === menu.id ? "fa fa-angle-up" : "fa fa-angle-down"
                  }
                ></i>
              </p>

              {/* MUI Collapse for smooth animation */}
              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      <Link to={sub.link} onClick={handleClick}>
                        {sub.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : (
            <Link to={menu.link} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
      {/* Click-to-call, mirroring the desktop top-bar button. */}
      <li>
        <a href="tel:+918929222212" aria-label="Call AXOIX on +91 89292 22212">
          <i className="fas fa-phone-alt" aria-hidden="true" style={{ marginRight: 8, color: "var(--color-primary)" }}></i>
          +91 89292 22212
        </a>
      </li>
      <li>
        <a
          href="https://wa.me/918929222212"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with AXOIX on WhatsApp"
        >
          <i className="fab fa-whatsapp" aria-hidden="true" style={{ marginRight: 8, color: "var(--color-primary)" }}></i>
          WhatsApp
        </a>
      </li>
    </ul>
  );
};

export default MobileMenu;
